import { initializeSliderRecommendations } from '../sliders/slider-recommendations';
import { resizeBackgroundImages } from '../utilities/responsive-images';
import { addProductItemSlats } from '../product/product-item-slats';

const loadProductRecommendationsIntoSection = () => {
  const productRecommendationsSection = document.querySelector('.js-product-recommendations');

  if (productRecommendationsSection === null) {
    return;
  }

  const productId = productRecommendationsSection.dataset.productId;
  const baseUrl = productRecommendationsSection.dataset.baseUrl;
  const limit = productRecommendationsSection.dataset.limit;
  const requestUrl = `${baseUrl}?section_id=product-recommendations&product_id=${productId}&limit=${limit}`;
  const request = new XMLHttpRequest();

  request.open('GET', requestUrl);

  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      const container = document.createElement('div');

      container.innerHTML = request.response;

      productRecommendationsSection.innerHTML = container.querySelector('.js-product-recommendations').innerHTML;

      const sliderFlickity = document.querySelector('.js-slider-recommendations');

      if (sliderFlickity === null) {
        return;
      }

      const slatsItems = $('[data="js-slats"]');

      for (let i = 0; i < slatsItems.length; i++) {
        const $item = $(slatsItems[i]);
        addProductItemSlats($item);
      }

      initializeSliderRecommendations();

      const sliderImages = document.querySelector('.js-slider-recommendations').querySelectorAll('.js-responsive-background-image');

      $(sliderFlickity).on( 'change.flickity', function() {
        resizeBackgroundImages(sliderImages);
      });

      $(sliderFlickity).on( 'scroll.flickity', function() {
        resizeBackgroundImages(sliderImages);
      });

      $(window).on('resize', function(event) {
        setTimeout(function() {
          $(sliderFlickity).flickity('reloadCells').flickity('reposition').flickity('resize');
        }, 300);
      });
    }
  };

  request.send();
};

loadProductRecommendationsIntoSection();

$(window).on('shopify:section:load', function(event) {
  loadProductRecommendationsIntoSection();
});

